import * as yup from "yup";

import { createConfig } from "./helpers/config.helpers";
import { toProductConfiguration } from "./helpers/productConfiguration.helpers";

const YIELD_PER_PACKAGE_FEATURE_CODE = "4.362";
const YIELD_PER_LITER_FEATURE_CODE = "4.385";
const CONTENT_FEATURE_CODE = "3.009";

const PaintCalculatorValidationSchema = yup.object({
    surface: yup
        .number()
        .transform((value) => (Number.isNaN(value) ? 1 : value))
        .positive()
        .required()
        .meta({ unit: "m²" })
});

const PrimerCalculatorValidationSchema = yup.object({
    surface: yup
        .number()
        .transform((value) => (Number.isNaN(value) ? 1 : value))
        .positive()
        .required()
        .meta({ unit: "m²" })
});

const FloorCalculatorValidationSchema = yup.object({
    area: yup
        .number()
        .transform((value) => (Number.isNaN(value) ? 1 : value))
        .positive()
        .required()
        .meta({ unit: "m²" })
});

const Paint = createConfig({
    id: "paint",
    schema: PaintCalculatorValidationSchema,
    identifiers: [
        "muur-en-plafondverf",
        "lakken",
        "vloerverf",
        "verf---houtbescherming"
    ],
    variants: ({ variant }) => [
        variant({
            codes: [YIELD_PER_PACKAGE_FEATURE_CODE],
            calculate: ({ input, values }) => {
                const coverage = values[YIELD_PER_PACKAGE_FEATURE_CODE];

                return (input.surface / coverage) * 2;
            }
        }),
        variant({
            codes: [CONTENT_FEATURE_CODE, YIELD_PER_LITER_FEATURE_CODE],
            calculate: ({ input, values }) => {
                const coverage =
                    values[CONTENT_FEATURE_CODE] *
                    values[YIELD_PER_LITER_FEATURE_CODE];

                return (input.surface / coverage) * 2;
            }
        })
    ]
});

const Primer = createConfig({
    id: "primer",
    schema: PrimerCalculatorValidationSchema,
    identifiers: ["primers"],
    variants: ({ variant }) => [
        variant({
            codes: [YIELD_PER_PACKAGE_FEATURE_CODE],
            calculate: ({ input, values }) => {
                const coverage = values[YIELD_PER_PACKAGE_FEATURE_CODE];

                return input.surface / coverage;
            }
        }),
        variant({
            codes: [CONTENT_FEATURE_CODE, YIELD_PER_LITER_FEATURE_CODE],
            calculate: ({ input, values }) => {
                const coverage =
                    values[CONTENT_FEATURE_CODE] *
                    values[YIELD_PER_LITER_FEATURE_CODE];

                return input.surface / coverage;
            }
        })
    ]
});

const Floor = createConfig({
    id: "floor",
    schema: FloorCalculatorValidationSchema,
    identifiers: ["plankenvloer", "vinyl", "laminaat"],
    variants: ({ variant }) => [
        variant({
            codes: [YIELD_PER_PACKAGE_FEATURE_CODE],
            calculate: ({ input, values }) => {
                const coverage = values[YIELD_PER_PACKAGE_FEATURE_CODE];

                return input.area / coverage;
            }
        })
    ]
});

export const CalculatorConfigs = [
    toProductConfiguration(Paint),
    toProductConfiguration(Primer),
    toProductConfiguration(Floor)
];
